import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ml-30" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "mb-x2" }
const _hoisted_4 = { class: "block font-bold" }
const _hoisted_5 = {
  key: 0,
  class: "block"
}
const _hoisted_6 = { class: "block" }
const _hoisted_7 = { key: 1 }

import {
    BasketAddress,
    BasketBuyer, PickAndPackCheckOutDeliverable,
} from '@/b2b/shared/api/server-apis';
import { computed, ComputedRef } from 'vue';
import { useCheckout } from '@/b2b/checkout/useCheckout';
import useBooleanToggle from '@/shared/useBooleanToggle';
import CheckoutChangeAddress from '@/b2b/checkout/ui/CheckoutChangeAddress.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPickAndPackHomeDeliveryInfo',
  props: {
    deliverable: null
  },
  setup(__props: any) {

const props = __props as {
    deliverable: PickAndPackCheckOutDeliverable;
}



const labels = useBlockLabels();
const { invoiceAddress, getHasPreviousShippingAddress } = useCheckout();
const { isToggled, toggle } = useBooleanToggle();

const deliveryAddress: ComputedRef<BasketAddress | undefined> = computed(() => {
    return props.deliverable.deliveryAddress?.address || invoiceAddress.value?.address;
});

const buyer: ComputedRef<BasketBuyer | undefined> = computed(() => {
    return props.deliverable.deliveryAddress?.buyer || invoiceAddress.value?.buyer;
});

const hasPreviousShippingAddress = computed(() => getHasPreviousShippingAddress(props.deliverable.id));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.deliverable.canChangeDeliveryAddress && _unref(hasPreviousShippingAddress))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "my-x2 bg-wild-sand p-x2 px-25",
          innerHTML: _unref(labels).splitDeliveryOnlyOneShippingAddressAllowed
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(labels).pickAndPackDeliveredToAddressTitle), 1),
      (_unref(buyer)?.companyName)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(buyer)?.companyName), 1))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(buyer)?.firstName) + " " + _toDisplayString(_unref(buyer)?.lastName), 1),
      _createVNode(_Transition, {
        name: "o-anim-fade-300",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("span", {
            key: __props.deliverable.deliveryAddress?.address?.id,
            class: "block"
          }, [
            _createTextVNode(_toDisplayString(_unref(deliveryAddress)?.street), 1),
            (_unref(deliveryAddress)?.street2)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(", " + _toDisplayString(_unref(deliveryAddress)?.street2), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]))
        ]),
        _: 1
      }),
      _createVNode(_Transition, {
        name: "o-anim-fade-300",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("span", {
            key: __props.deliverable.deliveryAddress?.address?.id,
            class: "block"
          }, _toDisplayString(_unref(deliveryAddress)?.postalCode) + " " + _toDisplayString(_unref(deliveryAddress)?.city), 1))
        ]),
        _: 1
      }),
      _createVNode(_Transition, {
        name: "o-anim-fade-300",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("span", {
            key: __props.deliverable.deliveryAddress?.address?.id,
            class: "block"
          }, _toDisplayString(_unref(deliveryAddress)?.country), 1))
        ]),
        _: 1
      })
    ]),
    (__props.deliverable.canChangeDeliveryAddress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "c-button c-button--outline",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(toggle) && _unref(toggle)(...args)), ["prevent"]))
          }, _toDisplayString(_unref(labels).pickAndPackChangeAddressButton), 1)
        ]))
      : _createCommentVNode("", true),
    (__props.deliverable.canChangeDeliveryAddress)
      ? (_openBlock(), _createBlock(CheckoutChangeAddress, {
          key: 2,
          "delivery-address": __props.deliverable.deliveryAddress,
          "is-open": _unref(isToggled),
          onClose: _unref(toggle)
        }, null, 8, ["delivery-address", "is-open", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}
}

})